var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineCurrent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "37px",
    height: "10px",
    viewBox: "0 0 14 4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10854",
    "data-name": "Group 10854",
    transform: "translate(-145 -227)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_478",
    "data-name": "Ellipse 478",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(145 227)",
    fill: "#015CA3"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_479",
    "data-name": "Ellipse 479",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(155 227)",
    fill: "#015CA3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76290",
    "data-name": "Path 76290",
    d: "M-7462.3-18780.5h-8.512v-1h8.512Z",
    transform: "translate(7619 19010)",
    fill: "#015CA3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineCurrent);
export default __webpack_public_path__ + "static/media/line_current.e4a7a1314039de8993dc4b817756d11a.svg";
export { ForwardRef as ReactComponent };